export default {
  title: "Hujjatlar",
  instruction: "Ko‘rsatma",
};
